module.exports = __webpack_public_path__ + "8f49e3f1818a1cfad4b9cb2a23c1165d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/rifa/components/layout/icons/bola.svg
// module id = 1038
// module chunks = 0